import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
    selector: 'app-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss'],
    standalone: false
})
export class ConfirmComponent {
  @Output() confirm = new EventEmitter<any>();
  @Input() yescolor = 'accent';
  open = false;
  constructor() {}

  onClick() {
    this.open = true;
  }

  doConfirm() {
    this.confirm.next(true);
    this.open = false;
  }

  cancelConfirm() {
    this.open = false;
  }
}

